import classNames from 'clsx';
import { ProgressBar, type ProgressBarProps } from 'react-aria-components';

import useIntl from '../hooks/useIntl/useIntl';
import { TXTCLI_LoadingXX } from '../translations';

import styles from './Loader.module.scss';

const Loader: React.FC = ({ className, ...props }: ProgressBarProps) => {
  const { formatMessage } = useIntl();

  return (
    <ProgressBar
      className={classNames(styles.loaderContainer, className)}
      isIndeterminate
      aria-label={formatMessage(TXTCLI_LoadingXX)}
      {...props}
    >
      <span className={styles.loader} />
      <span className={styles.loader} />
      <span className={styles.loader} />
      <span className={styles.loader} />
    </ProgressBar>
  );
};
export default Loader;
